export default __webpack_public_path__ + "static/SuisseIntl-Light-89a5107854b196db8ddeb8fd23ad8bec.woff2";